// @flow
import env from '../../environment';
import {deleteCreator, getCreator, postCreator, putCreator} from '../../http';

export const endpoints = Object.freeze({
  FETCH_CUSTOMERS: `${env.baseApiUrl}/im/admin/crm`,
  FETCH_CUSTOMER: `${env.baseApiUrl}/im/admin/crm/:customerId`,
  EDIT_CUSTOMER: `${env.baseApiUrl}/im/admin/crm/:customerId`,
  FETCH_CUSTOMER_MESSAGE: `${env.baseApiUrl}/im/admin/crm/message`,
  SAVE_CUSTOMER_MESSAGE: `${env.baseApiUrl}/im/admin/crm/message`,
  FETCH_CUSTOMER_CATEGORIES: `${env.baseApiUrl}/im/admin/crm/category`,
  CREATE_CUSTOMER_CATEGORY: `${env.baseApiUrl}/im/admin/crm/category`,
  EDIT_CUSTOMER_CATEGORY: `${env.baseApiUrl}/im/admin/crm/category/:categoryId`,
  EXPORT_CUSTOMERS: `${env.baseApiUrl}/im/admin/crm/export`,
});

export type CategoryRequest = {
  id?: string,
  name?: string,
  color?: string,
};

export const getCustomersApi = getCreator(endpoints.FETCH_CUSTOMERS);
export const getCustomerApi = getCreator(endpoints.FETCH_CUSTOMER);
export const editCustomerApi = putCreator(endpoints.EDIT_CUSTOMER);
export const editCustomerCategoryApi = putCreator(
  endpoints.EDIT_CUSTOMER_CATEGORY
);
export const deleteCustomerCategoryApi = deleteCreator(
  endpoints.EDIT_CUSTOMER_CATEGORY
);
export const getCustomerMessageApi = getCreator(
  endpoints.FETCH_CUSTOMER_MESSAGE
);
export const saveCustomerMessageApi = postCreator(
  endpoints.SAVE_CUSTOMER_MESSAGE
);
export const getCustomerCategoriesApi = getCreator(
  endpoints.FETCH_CUSTOMER_CATEGORIES
);
export const createCustomerCategoriesApi = postCreator(
  endpoints.CREATE_CUSTOMER_CATEGORY
);
